import HTTPClient from 'utils/HTTPClient';

export const getChildrenNewExercisesChart = async (childrenId: string): Promise<{ date: Date; count: number }[]> => {
  const data = await HTTPClient.get(`/children/${childrenId}/new-exercises-chart`);
  return data.data;
};
